var map = {
	"./accessible.svg": 2542,
	"./account_circle.svg": 9470,
	"./add.svg": 7941,
	"./ai.svg": 8075,
	"./arrow_back.svg": 7791,
	"./arrow_forward.svg": 9089,
	"./attach_file.svg": 549,
	"./avi.svg": 2649,
	"./biotech.svg": 6111,
	"./bmp.svg": 3685,
	"./bookmark.svg": 6451,
	"./calendar_month.svg": 6254,
	"./camping.svg": 4609,
	"./celebration.svg": 4424,
	"./checklist.svg": 6340,
	"./chevron_left.svg": 3723,
	"./chevron_right.svg": 7577,
	"./close.svg": 8707,
	"./contact_phone.svg": 3228,
	"./csv.svg": 9229,
	"./delete.svg": 5553,
	"./description.svg": 2562,
	"./diversity_4.svg": 3764,
	"./dm.svg": 8870,
	"./dmg.svg": 806,
	"./doc.svg": 3881,
	"./docx.svg": 4094,
	"./dokument.svg": 18,
	"./done.svg": 4356,
	"./download.svg": 4773,
	"./draft.svg": 8013,
	"./eps.svg": 675,
	"./euro.svg": 2564,
	"./event.svg": 7654,
	"./exe.svg": 7065,
	"./expand_less.svg": 4670,
	"./expand_more.svg": 4327,
	"./facebook_icon.svg": 9342,
	"./fast_forward.svg": 3374,
	"./fast_rewind.svg": 6463,
	"./favorite.svg": 3062,
	"./file_copy.svg": 1632,
	"./folder_open.svg": 6157,
	"./forest.svg": 1459,
	"./format_list_bulleted.svg": 8913,
	"./genetics.svg": 5704,
	"./gif.svg": 963,
	"./github_icon.svg": 6492,
	"./gitlab_icon.svg": 6020,
	"./groups.svg": 7502,
	"./handshake.svg": 8551,
	"./help.svg": 3377,
	"./history.svg": 9074,
	"./history_edu.svg": 6485,
	"./home.svg": 5859,
	"./hourglass_empty.svg": 1827,
	"./info.svg": 4743,
	"./instagram_icon.svg": 3886,
	"./interests.svg": 7686,
	"./iso.svg": 8785,
	"./jpeg.svg": 4998,
	"./lab_research.svg": 3668,
	"./labs.svg": 7445,
	"./language.svg": 905,
	"./lightbulb.svg": 2499,
	"./link.svg": 246,
	"./linkedin_icon.svg": 3939,
	"./local_activity.svg": 2940,
	"./local_library.svg": 9709,
	"./location_home.svg": 3023,
	"./lock.svg": 2687,
	"./mail.svg": 7932,
	"./map.svg": 8438,
	"./menu.svg": 2483,
	"./minimize.svg": 9750,
	"./mov.svg": 2178,
	"./movie.svg": 5215,
	"./mp3.svg": 365,
	"./mp4.svg": 8149,
	"./mpg.svg": 215,
	"./neurology.svg": 5847,
	"./note_add.svg": 8363,
	"./odp.svg": 397,
	"./ods.svg": 3103,
	"./odt.svg": 6558,
	"./open_in_new.svg": 5906,
	"./otf.svg": 379,
	"./pause_circle.svg": 4101,
	"./pdf.svg": 8393,
	"./perm_media.svg": 4983,
	"./person.svg": 7315,
	"./phone_in_talk.svg": 2814,
	"./picture_as_pdf-1.svg": 7725,
	"./picture_as_pdf-2.svg": 4097,
	"./picture_as_pdf-3.svg": 505,
	"./picture_as_pdf-4.svg": 8283,
	"./picture_as_pdf.svg": 6325,
	"./play_circle.svg": 8161,
	"./png.svg": 9586,
	"./ppt.svg": 8582,
	"./pptx.svg": 897,
	"./ps.svg": 7064,
	"./psd.svg": 490,
	"./psychology.svg": 9901,
	"./public.svg": 4006,
	"./qr_code.svg": 3648,
	"./quiz.svg": 3261,
	"./refresh.svg": 568,
	"./repeat.svg": 240,
	"./rocket_launch.svg": 7061,
	"./rss.svg": 8681,
	"./rtf.svg": 5674,
	"./save.svg": 9646,
	"./school.svg": 7276,
	"./science.svg": 2466,
	"./search.svg": 7147,
	"./settings.svg": 810,
	"./share.svg": 9451,
	"./shuffle.svg": 931,
	"./speaker_notes.svg": 9749,
	"./svg.svg": 6834,
	"./swap_horiz.svg": 2064,
	"./sync.svg": 2099,
	"./tar.svg": 1611,
	"./task.svg": 1714,
	"./thumb_down.svg": 3321,
	"./thumb_up.svg": 5044,
	"./tif.svg": 4922,
	"./tiktok_icon.svg": 9640,
	"./tips_and_updates.svg": 9200,
	"./ttf.svg": 453,
	"./twitter_icon.svg": 1077,
	"./txt.svg": 9939,
	"./upload.svg": 9642,
	"./volunteer_activism.svg": 5093,
	"./warning.svg": 4861,
	"./wav.svg": 6735,
	"./webp.svg": 8564,
	"./work_history.svg": 7356,
	"./xing_icon.svg": 2372,
	"./xls.svg": 5901,
	"./xlsx.svg": 5230,
	"./youtube_icon.svg": 6734,
	"./zip.svg": 4994,
	"./zoom_in.svg": 8665,
	"./zoom_out.svg": 7078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3266;